import styled from 'styled-components';

export const StyledShellLayout = styled.div`
  height: 100vh;
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;

  /* Reason for using min-width - https://leonardofaria.net/2020/07/18/using-flexbox-and-text-ellipsis-together */
  min-width: 0;
  display: flex;
  position: relative;
  flex-direction: column;
`;
